import * as React from 'react';
import { useColorScheme } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

export default function ColorModeSelect(props) {
  const { mode, colorScheme, setMode, setColorScheme } = useColorScheme();
  if (!mode) {
    return null;
  }
  const currentValue = colorScheme === 'warm' ? 'warm' : mode;
  const handleChange = (event) => {
    const value = event.target.value;
    if (value === 'system') {
      setMode('system');
      setColorScheme('light');
    } else if (value === 'warm') {
      setColorScheme('warm');
    } else {
      setColorScheme(value);
      setMode(value);
    }
  };
  return (
    <Select
      value={currentValue}
      onChange={handleChange}
      SelectDisplayProps={{
        'data-screenshot': 'toggle-mode',
      }}
      {...props}
    >
      <MenuItem value="system">System</MenuItem>
      <MenuItem value="light">Light</MenuItem>
      <MenuItem value="warm">Warm</MenuItem>
      <MenuItem value="dark">Dark</MenuItem>
    </Select>
  );
}
